<template>
  <div
    class="v-application v-application--is-ltr theme--light menuable__content__active"
  >
    <div class="row">
      <div class="col-md-3">
        <b-form-group>
          <h6 class="mb-1">Role</h6>
          <search-select
            v-model="selectedRoleId"
            :options="roleOptions"
          ></search-select>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-xxl-12 col-12 col-md-12">
        <b-card>
          <b-button variant="primary gutter-b" @click="handleButtonAdd()"
            >Tambah</b-button
          >
          <div class="table-responsive">
            <b-table
              hover
              :items="tableData"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isLoading"
              show-empty
            >
              <template #cell(role_id)="row">
                {{ getRoleName(row.item.role_id) }}
              </template>
              <template #cell(action)="row">
                <span class="mr-2" @click="handleEdit(row.item)">
                  <b-button
                    variant="warning"
                    class="py-1 px-2"
                    id="edit"
                    title="edit"
                  >
                    <i class="menu-icon flaticon-edit pr-0"></i>
                  </b-button>
                </span>
              </template>
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
          </div>
          <div class="row justify-content-between">
            <div class="col-md-1">
              <b-form-group class="mb-0">
                <search-select
                  id="per-page-select"
                  v-model="perPage"
                  :options="pageOptions"
                  size="sm"
                ></search-select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                size="md"
                align="fill"
                class="ml-auto"
                style="padding: 0"
              ></b-pagination>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "ListLoanSize",
  data() {
    return {
      isLoading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, { value: 100, text: "Show a lot" }],
      tableData: [],
      selectedRoleId: "",
      roleOptions: [{ value: "", text: "Global (All Roles)" }],
      roleMap: {},
      fields: [
        {
          key: "amount",
          label: "Amount",
        },
        {
          key: "admin_fee",
          label: "Admin Fee",
        },
        {
          key: "role_id",
          label: "Role",
        },
        {
          key: "action",
          label: "Action",
          align: "center",
          width: "10%",
        },
      ],
    };
  },
  async mounted() {
    await this.getRoles();
    this.getData();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "/dashboard" },
      { title: "Loan Size" },
    ]);
  },
  methods: {
    handleButtonAdd() {
      this.$router.push({ path: "/loan-size/create" });
    },
    handleEdit(item) {
      this.$router.push({ path: `/loan-size/edit/${item.id}` });
    },
    getRoleName(roleId) {
      if (!roleId) return "Global";
      return this.roleMap[roleId] || roleId;
    },
    extractList(data) {
      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.list)) return data.list;
      if (Array.isArray(data?.items)) return data.items;
      if (Array.isArray(data?.data)) return data.data;
      return [];
    },
    async getRoles() {
      try {
        const { data } = await this.$axios.get(
          `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/roles`
        );
        const roles = Array.isArray(data) ? data : data?.list || [];
        this.roleOptions = [{ value: "", text: "Global (All Roles)" }];
        this.roleMap = {};
        roles.forEach((role) => {
          this.roleOptions.push({
            value: role.id,
            text: role.name,
          });
          this.roleMap[role.id] = role.name;
        });
      } catch ({ response }) {
        this.$bvToast.toast(response?.data?.message ?? "Terjadi Kesalahan", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },
    async getData() {
      this.isLoading = true;
      try {
        const params = {};
        if (this.selectedRoleId) params.role_id = this.selectedRoleId;
        const { data } = await this.$axios.get(
          `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/loan-size`,
          { params }
        );
        this.tableData = this.extractList(data);
        this.totalRows = this.tableData.length;
      } catch ({ response }) {
        this.$bvToast.toast(response?.data?.message ?? "Terjadi Kesalahan", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    selectedRoleId() {
      this.currentPage = 1;
      this.getData();
    },
  },
};
</script>
